export default function (rates: Array<{ currency: string; rate: number }>) {
  const ratesList: Record<string, number> = {};
  rates.forEach((rate) => {
    ratesList[rate.currency] = rate.rate;
  });
  return ratesList;
}
